/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ZzzingServicePricing } from './zzzingServicePricing';


/**
 * Pricing for a particular property and location configuration
 */
export interface ZzzingServicePricingAndAvailability { 
    property_id?: string;
    location?: string;
    available?: boolean;
    pricing?: ZzzingServicePricing;
}

